import { Menu } from "semantic-ui-react";
import React from "react";
import { NavLink, useRouteMatch } from "react-router-dom";

export const EmployeeTeamTabs = () => {
  let { url } = useRouteMatch();

  return (
    <Menu secondary pointing stackable>
      <Menu.Item as={NavLink} to={`${url}/liderados`}>
        Meus liderados
      </Menu.Item>
      <Menu.Item as={NavLink} to={`${url}/organograma`}>
        Organograma
      </Menu.Item>
      <Menu.Item as={NavLink} to={`${url}/secundario`}>
        Equipes secundárias
      </Menu.Item>
    </Menu>
  );
};
